module.exports = __webpack_public_path__ + "static/img/paimingbiaoqian.a03ad034.png";